import mapProps from '../scripts/utils/map-props';
import Tabs from './tabs';

export default mapProps(
  [
    {
      name: 'value',
    },
  ],
  {
    model: {
      prop: 'value',
      event: ['change', 'input'],
    },
  }
)(Tabs);
